import assign from 'lodash/assign';
import reduce from 'lodash/reduce';

const actions = [
  // app
  'SET_APP_VALUES',
  'SET_DATA_LOADING',

  // address
  'SET_ADDRESS',

  // comparable listings
  'SET_COMPARABLES',

  // filters
  'UPDATE_FILTER',

  // ui
  'SET_HOVER_ID',
  'SET_ACTIVE_ID',

  'INIT_SET_FILTER',

  'INIT_USER',
];

const dispatchConstants = reduce(
  actions,
  (accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
  },
  {},
);

const constants: any = ({} = assign({}, dispatchConstants)); // eslint-disable-line no-empty-pattern
export type AllActionTypes = (typeof actions)[number];
export default constants;
